import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { EmojiComponent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { ClickOutSideDirective } from '../../../../../../ui-components/directives/clickOutSide.directive';
import { CloseIconComponent, EmojiIconComponent } from '@kuiper/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { Editor } from '@tiptap/core';
import { ReportService } from '../../../../../common/services/report/report.service';
import { FeatureFlagsService } from '../../../../../common/services/feature-flags/feature-flags.service';

@Component({
  selector: 'lib-discussion-emoji-picker',
  imports: [
    EmojiComponent,
    NgTemplateOutlet,
    ClickOutSideDirective,
    ReactiveFormsModule,
    CloseIconComponent,
    EmojiIconComponent,
    TranslocoPipe,
  ],
  templateUrl: './discussion-emoji-picker.component.html',
  styleUrl: './discussion-emoji-picker.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DiscussionEmojiPickerComponent {
  private readonly parentContainer = inject(ControlContainer);
  private readonly reportService = inject(ReportService);
  private readonly featureFlagService = inject(FeatureFlagsService);

  inputFormControlName = input.required<string>();
  emojiSize = input<number>(16);
  containerRef = input.required<string>();
  tiptapEditor = input<Editor | null>(null);
  searchPlaceholder = signal<string>('Search by name');

  isPickerListOpen = signal<boolean>(false);

  emojiSizeInPixels = computed(() =>
    this.reportService.getCurrentValueInPixels(this.emojiSize() / 16)
  );

  emojiList = signal<any[]>([
    {
      emoji: [
        ':thumbsup::skin-tone-1:',
        ':thumbsdown::skin-tone-1:',
        ':clap::skin-tone-1:',
        ':tada::skin-tone-1:',
        ':100:',
        ':pray::skin-tone-3:',
        ':arrow_up:',
        ':arrow_down:',
      ],
    },
  ]);

  private get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }

  get childControl() {
    return this.parentFormGroup?.controls[
      this.inputFormControlName()
    ] as FormControl;
  }

  toggleEmojiPicker() {
    this.isPickerListOpen.set(!this.isPickerListOpen());
  }

  addEmoji(event: any) {
    const emoji = event.emoji.native;
    this.tiptapEditor()?.chain().focus().insertContent(emoji).run();
  }
}
